module.exports = __webpack_public_path__ + "static/media/Desinfektionsspender.1846abd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Desinfektionsspender.png
// module id = 138
// module chunks = 0